module.exports = __webpack_public_path__ + "assets/bone.4971f5a2.svg";